import { createSlice } from "@reduxjs/toolkit";
import { deletePortfolio } from "./actions";

const initialState = {
    portfolios: [],
    activePortfolio: {},
    portfolioDetail: {
        assets: [],
        allocation: null,
        statistic: {
            best: null,
            total: null,
            worst: null,
        },
    },
};

export const portfolioSlice = createSlice({
    name: "Portfolio",
    initialState,
    reducers: {
        setPortfolios: (state, action) => {
            state.portfolios = action.payload;
        },

        setActivePortfolio: (state, action) => {
            state.activePortfolio = action.payload;
        },

        addPortfolio: (state, action) => {
            state.portfolios.push(action.payload);

            if (state.portfolios.length === 1) {
                state.activePortfolio = action.payload;
            }
        },

        updatePortfolioName: (state, action) => {
            let item = action.payload;

            // edit name from list
            for (let i = 0; i < state.portfolios.length; i++) {
                const element = state.portfolios[i];
                if (element.id === item.id) {
                    element.name = item.name;
                }
            }

            // edit active name
            state.activePortfolio.name = item.name;
        },

        setPortfolioDetail: (state, action) => {
            let data = action.payload;

            state.portfolioDetail = {
                assets: data.assets,
                allocation: data.allocation,
                statistic: data.statistic,
            };

            // update active portfolio
            state.activePortfolio.balance = data.balance;

            // update portfolio balance in portfolios
            for (let i = 0; i < state.portfolios.length; i++) {
                const element = state.portfolios[i];
                if (element.id === state.activePortfolio.id) {
                    element.balance = data.balance;
                }
            }
        },
    },
    extraReducers: {
        [deletePortfolio.fulfilled]: (state, action) => {
            let id = action.payload;

            if (id) {
                // remove from list
                state.portfolios = state.portfolios.filter((item) => item.id !== id);

                // add first item of list for active
                state.activePortfolio = state.portfolios.length ?
                    state.portfolios[0] :
                    {};
            }
        },
    },
});

// Action creators are generated for each case reducer function
export const {
    setPortfolios,
    setActivePortfolio,
    addPortfolio,
    updatePortfolioName,
    setPortfolioDetail,
} = portfolioSlice.actions;

export default portfolioSlice.reducer;